import './styles/auth-ui-surface.css';
import { ensureAuthUiFonts } from './utils/ensure-auth-fonts';

export { GlanceAuthLogin, GlanceAuthForbidden } from './components/auth';

if (typeof document !== 'undefined') {
  ensureAuthUiFonts();
}
